export const Translations = {
    'en': {
        'label': 'Select Option',
        'requiredMessage': 'This field is required. '
    },
    'es': {
        'label': 'Seleccionar opción',
        'requiredMessage': 'Este campo es requerido. '
    },
    'ja': {
        'label': 'Select Option',
        'requiredMessage': 'This field is required. '
    },
    'zh': {
        'label': '选择选项',
        'requiredMessage': '这是必填栏'
    }
};
